import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { FinancialKnowledge } from '@app/forms/subscription/definition/interface/subscription';
import FormGroupArray from '../../services/FormGroupArray';
import { Parameters } from '@app/forms/subscription/definition/interface/Pledge';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: FinancialKnowledge & { riskProfil: any }, option) {
    let options: AbstractControlOptions = {};
    return this.formBuilder.group(
      {
        ownerId: [entity.ownerId],
        userFirstName: [entity.userFirstName],
        userLastName: [entity.userLastName],
        // workInFinance: [entity?.workInFinance || "NO", Validators.required],

        // credit: [entity?.credit || "NO", Validators.required],
        // readSpecializedPress: [
        //   entity?.readSpecializedPress || "NO",
        //   Validators.required,
        // ],
        riskProfil: this.formBuilder.group({
          credit: [entity?.riskProfil?.credit || 'NO', Validators.required],
          workInFinance: [
            entity?.riskProfil?.workInFinance || 'NO',
            Validators.required,
          ],
          readSpecializedPress: [
            entity?.riskProfil?.readSpecializedPress || 'NO',
            Validators.required,
          ],
        }),
      },
      options,
    );
  }
  generate(entity: FinancialKnowledge[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }

  extract() {
    return this.form.value.owners;
  }
}
